<template>
  <ReSendEmailManagerModal
    v-if="showReSendEmailManagerModal"
    :measureId="measureIdSelected"
    @closeModal="closeModal"
  />
  <div class="mb-3">
    <h2 class="fw-light d-flex align-items-center mb-0">
      <router-link
        to="/home"
        class="d-flex align-items-center me-2"
        title="Voltar"
      >
        <i class="ph-caret-circle-left ph-2x" />
      </router-link>
      Minhas Medições
    </h2>
  </div>
  <ul
    class="nav nav-pills nav-pills-outline nav-pills-toolbar nav-justified mb-4"
    role="tablist"
  >
    <li class="nav-item">
      <a
        type="button"
        role="tab"
        class="nav-link active"
        data-bs-toggle="tab"
        data-bs-target="#aguardando-aprovacao"
        aria-controls="aguardando-aprovacao"
        aria-selected="true"
        title="Aguardando Aprovação"
      >
        Aguardando Aprovação
      </a>
    </li>
    <li class="nav-item">
      <a
        type="button"
        role="tab"
        class="nav-link"
        data-bs-toggle="tab"
        data-bs-target="#todas"
        aria-controls="todas"
        aria-selected="false"
        title="Todas"
      >
        Todas
      </a>
    </li>
  </ul>
  <div class="tab-content">
    <div
      class="tab-pane fade show active"
      id="aguardando-aprovacao"
      role="tabpanel"
      aria-labelledby="aguardando-aprovacao-tab"
    >
      <LoadingData v-if="isLoadingMyMeasuresAwaitingApproval" />
      <DataTableDefault
        v-else
        :dataTable="dataTableMyMeasuresAwaitingApproval"
        :options="optionsDataTableMyMeasuresAwaitingApproval"
        customClass="table-xs fs-sm"
        @reSendEmailManagerModal="reSendEmailManagerModal"
      />
    </div>
    <div
      class="tab-pane fade"
      id="todas"
      role="tabpanel"
      aria-labelledby="todas-tab"
    >
      <div class="card border-start border-start-width-2 border-start-primary">
        <div class="card-body">
          <div class="row g-3">
            <div class="col-12 col-md-4">
              <label class="form-label">Data Inicial:</label>
              <input
                type="date"
                class="form-control"
                v-model="filters.startDate"
              />
            </div>
            <div class="col-12 col-md-4">
              <label class="form-label">Data Final:</label>
              <input
                type="date"
                class="form-control"
                v-model="filters.endDate"
              />
            </div>
            <div class="col-12 col-md-4">
              <label class="form-label">Status:</label>
              <select class="form-select" v-model="filters.status">
                <option value="">Selecione</option>
                <option v-for="s in status" :key="s.code" :value="s.code">
                  {{ s.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="text-end mt-3">
            <button
              type="button"
              class="btn btn-success rounded-pill"
              title="Buscar"
              :disabled="disableButton"
              @click="getMyMeasures"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner me-2" />Buscar
              </span>
              <span v-else><i class="ph-magnifying-glass me-2" />Buscar</span>
            </button>
          </div>
        </div>
      </div>
      <LoadingData v-if="isLoadingMyMeasures" />
      <DataTableDefault
        v-else
        :dataTable="dataTableMyMeasures"
        :options="optionsDataTableMyMeasures"
        customClass="table-xs fs-sm"
      />
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import ReSendEmailManagerModal from '@/components/report/ReSendEmailManagerModal.vue'
import DataTableDefault from '@/components/commons/DataTableDefault.vue'
import { formatToCurrencyBr } from '@/utils/currency'
import { dateNowUs30ago, dateNowUs, dateTimeRmToDateBR } from '@/utils/date'
import { measureStatus } from '@/utils/status'

export default {
  name: 'MyMeasures',

  components: {
    LoadingData,
    ReSendEmailManagerModal,
    DataTableDefault,
  },

  data() {
    return {
      isLoadingMyMeasuresAwaitingApproval: true,
      isLoadingMyMeasures: true,
      dataTableMyMeasuresAwaitingApproval: {
        columns: [
          {
            data: 'identificador',
            title: 'Identificador',
          },
          {
            data: 'providerName',
            title: 'Fornecedor',
          },
          {
            data: 'costCenter',
            title: 'Centro de Custo',
          },
          {
            data: 'createdAt',
            title: 'Criação',
          },
          {
            data: 'itemName',
            title: 'Item',
          },
          {
            data: 'totalValue',
            title: 'Valor',
          },
          {
            data: 'link',
            title: 'Ações',
            searchable: false,
            orderable: false,
            render(value, type, row) {
              const path = row.type === 'Contrato' ? 'contracts' : 'moviments'
              return `
                <a href="#" data-item-emit="reSendEmailManagerModal" data-item-id="${row.id}" class="badge bg-info cursor-pointer" title="Reenviar e-mail para gestores"">
                  Reenviar E-mail
                </a>
                <a href="#" data-item-router="/documents/${path}" data-item-id="${value}" class="badge bg-primary mt-2" title="Detalhar ${row.type} ${value}">
                  Detalhar
                </a>`
            },
          },
        ],
        data: [],
      },
      optionsDataTableMyMeasuresAwaitingApproval: {
        order: [[3, 'desc']],
        columnDefs: [{ targets: [6], className: 'text-center' }],
      },
      showReSendEmailManagerModal: false,
      measureIdSelected: null,
      filters: {
        startDate: dateNowUs30ago(),
        endDate: dateNowUs(),
        status: '',
      },
      status: [
        { code: '100', name: 'Aguardando Aprovação' },
        { code: '150', name: 'Aprovado' },
        { code: '160', name: 'Faturado' },
        { code: '190', name: 'Reprovado' },
        { code: '191', name: 'Cancelado' },
      ],
      dataTableMyMeasures: {
        columns: [
          {
            data: 'identificador',
            title: 'Identificador',
          },
          {
            data: 'providerName',
            title: 'Fornecedor',
          },
          {
            data: 'contractNumber',
            title: 'Número',
          },
          {
            data: 'costCenter',
            title: 'Centro de Custo',
          },
          {
            data: 'createdAt',
            title: 'Criação',
          },
          {
            data: 'itemName',
            title: 'Item',
          },
          {
            data: 'totalValue',
            title: 'Valor',
          },
          {
            data: 'statusName',
            title: 'Status',
            render(value, type, row) {
              return measureStatus(row.status, value)
            },
          },
          {
            data: 'link',
            title: 'Ações',
            searchable: false,
            orderable: false,
            render(value, type, row) {
              const path = row.type === 'Contrato' ? 'contracts' : 'moviments'
              return `
                <a href="#" data-item-router="/documents/${path}" data-item-id="${value}" class="badge bg-primary" title="Detalhar ${row.type} ${value}">
                  Detalhar
                </a>`
            },
          },
        ],
        data: [],
      },
      optionsDataTableMyMeasures: {
        order: [[4, 'desc']],
        columnDefs: [{ targets: [8], className: 'text-center' }],
      },
      disableButton: false,
    }
  },

  methods: {
    async getMyMeasuresAwaitingApproval() {
      try {
        this.isLoadingMyMeasuresAwaitingApproval = true

        const data = await this.$store.dispatch('getMyMeasuresAwaitingApproval')

        this.dataTableMyMeasuresAwaitingApproval.data = data.map((line) => {
          return {
            id: line.id,
            identificador:
              line.type === 'Contrato' ? line.contractId : line.idmov,
            type: line.type,
            providerName: line.providerName,
            contractNumber: line.contractNumber,
            costCenter: line.costCenter,
            createdAt: dateTimeRmToDateBR(line.createdAt),
            itemName: line.itemName,
            totalValue: formatToCurrencyBr(line.totalValue),
            statusName: line.statusName,
            link: line.type === 'Contrato' ? line.contractId : line.idmov,
          }
        })

        this.isLoadingMyMeasuresAwaitingApproval = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getMyMeasures() {
      try {
        this.isLoadingMyMeasures = true
        this.disableButton = true

        const data = await this.$store.dispatch('getMyMeasures', this.filters)

        this.dataTableMyMeasures.data = data.map((line) => {
          return {
            identificador:
              line.type === 'Contrato' ? line.contractId : line.idmov,
            type: line.type,
            providerName: line.providerName,
            contractNumber: line.contractNumber,
            costCenter: line.costCenter,
            createdAt: dateTimeRmToDateBR(line.createdAt),
            itemName: line.itemName,
            totalValue: formatToCurrencyBr(line.totalValue),
            status: line.status,
            statusName: line.statusName,
            link: line.type === 'Contrato' ? line.contractId : line.idmov,
          }
        })

        this.isLoadingMyMeasures = false
        this.disableButton = false
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    reSendEmailManagerModal(measureId) {
      this.measureIdSelected = measureId
      this.showReSendEmailManagerModal = true
    },

    closeModal() {
      this.showReSendEmailManagerModal = false
    },
  },

  mounted() {
    this.getMyMeasuresAwaitingApproval()
    this.getMyMeasures()
  },
}
</script>
